enum SlidingPageAction {
    OPEN_SLIDING_PAGE = "OPEN_SLIDING_PAGE",
    DISMISS_SLIDING_PAGE = "DISMISS_SLIDING_PAGE"
}

export default SlidingPageAction;